import { render, staticRenderFns } from "./DesktopImg.vue?vue&type=template&id=0acca0c0&"
import script from "./DesktopImg.vue?vue&type=script&lang=js&"
export * from "./DesktopImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0acca0c0')) {
      api.createRecord('0acca0c0', component.options)
    } else {
      api.reload('0acca0c0', component.options)
    }
    module.hot.accept("./DesktopImg.vue?vue&type=template&id=0acca0c0&", function () {
      api.rerender('0acca0c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/Captures/components/DesktopImg.vue"
export default component.exports